<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-text-field
            v-model="search"
            label="Search by Username"
            outlined
            placeholder="Search"
            dense
            class="ml mt"
          ></v-text-field>
        </v-row>
        <v-data-table :headers="headers" :items="users" :search="search" :items-per-page="10">
          <template v-slot:item="{ item }">
            <tr>
              <v-tooltip bottom z-index="999" color="black" open-delay="200">
                <template v-slot:activator="{ on }">
                  <td style="cursor: pointer;" v-on="on" @click="onRowClick(item)">
                    {{ item.username }}
                  </td>
                  <td style="cursor: pointer;" v-on="on" @click="onRowClick(item)">
                    {{ item.rolesNames }}
                  </td>
                </template>
                <span class="tooltiptextRaceNavigation caption"><pre class="tooltipTextRaceNavigationPreformatted">Click to edit</pre></span>
              </v-tooltip>
              <td>
                <v-btn x-small fab color="#425058" style="margin-left: 12px !important;" @click="removeUser(item.username)">
                  <v-icon color="white">mdi-account-minus</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

  export default {
    data: () => ({
      search: '',
      headers: [
        {
          text: 'Username',
          value: 'username'
        },
        {
          text: 'Roles',
          value: 'roles'
        },
        {
          text: 'Actions',
          value: 'actions',
          filterable: false,
        }
      ]
    }),
    computed: {
      ...mapGetters(['getUsersWithRoles']),
      users () {
        return this.getUsersWithRoles
      }
    },
    methods: {
      ...mapActions(['deleteUserWithRoles', 'fetchUserWithRoles']),
      async removeUser (username) {
        await this.deleteUserWithRoles({ username: username })
        await this.fetchUserWithRoles()
      },
      onRowClick(rowData){
        this.$emit('rowClicked', rowData)
      }
    }
  }
</script>
